import classNames from 'classnames';
import { useId } from 'react';

const Radio = (props) => {
  const {
    field,
    label,
    value,
    form,
    onChange,
    onBlur,
    dataTestId = 'c7-radio'
  } = props;
  const { labelClass } = props;
  const { name, onChange: onFieldChange, onBlur: onFieldBlur } = field;
  const { values } = form;

  const fieldId = useId();

  const id = `c7-${fieldId}-${name}-${value}`;
  const labelId = `${id}-label`;

  const handleOnChange = (e) => {
    onFieldChange(e);
    if (onChange) {
      setTimeout(() => onChange(e), 1);
    }
  };

  const handleOnBlur = (e) => {
    onFieldBlur(e);
    if (onBlur) {
      setTimeout(() => onBlur(e), 1);
    }
  };

  return (
    <>
      <label
        data-testid={dataTestId}
        className={classNames('c7-radio', labelClass)}
        htmlFor={id}
        id={labelId}
      >
        <input
          type="radio"
          name={name}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          checked={value === values[name]}
          value={value}
          id={id}
          aria-labelledby={labelId}
        />
        <span className="c7-radio__control" />
        <span className="c7-radio__label">{label}</span>
      </label>
    </>
  );
};

export default Radio;
